import { removeToken, setAccessToken, setRefreshToken } from '@utils/token/authTokens';
import {
  ACCESS_TOKEN_KEY,
  IMPERSONATE_ACCESS_TOKEN_KEY,
  IMPERSONATE_REFRESH_TOKEN_KEY,
  REFRESH_TOKEN_KEY,
} from '@utils/token/constants';
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';

export const useTokenManagement = () => {
  const getTokens = ({ isImpersonate }: { isImpersonate?: boolean } = { isImpersonate: false }) => {
    if (isImpersonate)
      return {
        accessToken: Cookies.get(IMPERSONATE_ACCESS_TOKEN_KEY as string),
        refreshToken: Cookies.get(IMPERSONATE_REFRESH_TOKEN_KEY as string),
      };
    return {
      accessToken: Cookies.get(ACCESS_TOKEN_KEY as string),
      refreshToken: Cookies.get(REFRESH_TOKEN_KEY as string),
    };
  };

  const setTokens = ({
    accessToken,
    refreshToken,
    isImpersonate,
  }: {
    accessToken?: string;
    refreshToken: string;
    isImpersonate?: boolean;
  }) => {
    if (isImpersonate) {
      accessToken && setAccessToken({ key: IMPERSONATE_ACCESS_TOKEN_KEY, token: accessToken });
      setRefreshToken({ key: IMPERSONATE_REFRESH_TOKEN_KEY, token: refreshToken });
    } else {
      accessToken && setAccessToken({ key: ACCESS_TOKEN_KEY, token: accessToken });
      setRefreshToken({ key: REFRESH_TOKEN_KEY, token: refreshToken });
    }
  };

  const clearTokens = ({ isImpersonate }: { isImpersonate?: boolean } = { isImpersonate: false }) => {
    if (!isImpersonate) {
      removeToken(REFRESH_TOKEN_KEY as string);
      removeToken(ACCESS_TOKEN_KEY as string);
    }
    removeToken(IMPERSONATE_ACCESS_TOKEN_KEY as string);
    removeToken(IMPERSONATE_REFRESH_TOKEN_KEY as string);
  };

  const getIsAdmin = ({ isImpersonate }: { isImpersonate?: boolean } = { isImpersonate: false }) => {
    const accessToken = getTokens({ isImpersonate }).accessToken;
    const decodedToken: { isAdmin: boolean } = accessToken ? jwtDecode(accessToken) : { isAdmin: false };

    return decodedToken.isAdmin;
  };

  return {
    getIsAdmin,
    getTokens,
    setTokens,
    clearTokens,
  };
};
